
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shuffle } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { EmptyABTestState } from '@/components/ab-test/EmptyABTestState';
import { useAuth } from '@/hooks/useAuth';
import { useABTestStore } from '@/store/ab-test/abTestStore';
import { t } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

const ABTest = () => {
  useLanguage();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { tests, isLoading, fetchUserTests } = useABTestStore();
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  useEffect(() => {
    if (user?.id_user) {
      fetchUserTests(user.id_user).then(() => {
        setInitialCheckDone(true);
      });
    }
  }, [user?.id_user, fetchUserTests]);

  useEffect(() => {
    if (initialCheckDone && tests.length > 0) {
      navigate('/ab-test/list');
    }
  }, [initialCheckDone, tests, navigate]);

  const handleCreateTest = () => {
    navigate('/ab-test/create');
  };

  if (!initialCheckDone || isLoading) {
    return (
      <Layout fixedSidebar>
        <div className="p-6 flex items-center justify-center h-[80vh]">
          <div className="animate-pulse text-xl">{t('loading')}</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout fixedSidebar>
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header Premium */}
        <div className="flex-shrink-0 bg-transparent">
          <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-4 md:pt-4 pb-4 md:pb-5">
            <div className="flex items-center gap-2.5">
              <Shuffle className="h-[18px] w-[18px] text-[#2D6CF6]" strokeWidth={2} />
              <h1 className="text-[20px] md:text-[22px] font-semibold text-[#1E2330] tracking-tight leading-[1.2]">
                {t('testeAB')}
              </h1>
            </div>
          </div>
          <div className="hidden lg:block h-px w-full" style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} />
        </div>

        <div className="flex-1 overflow-y-auto">
          <div className="max-w-[1600px] px-4 sm:px-6 pt-6 pb-6 mx-auto">
            <EmptyABTestState onCreateNew={handleCreateTest} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ABTest;
